export default __webpack_public_path__ + "static/media/CRISIL_Report_on_Yarn_Manufacturing_in_India.1ee0ade5.pdf";